import { LegalComplianceLicenses } from './legal-compliance-licenses.model';

export class CompanyLicense {
  legalCompliance: LegalComplianceLicenses;

  constructor(companyLicense: Partial<CompanyLicense>) {
    Object.assign(this, companyLicense);
  }
}
